<template>
  <Instance
    instance="shiftPositions"
    instance-name="Shift Positions"
    :create="d => shiftPositions.create(d)"
    :delete="d => shiftPositions.remove(d)"
    :update="d => shiftPositions.update(d)"
    :get="d => shiftPositions.get(d)"
    :upsert="upsert"
    :columns="columns"
  />
</template>

<script>
import { BIconPencil } from 'bootstrap-vue';

import Instance from '../../CRUD/instance';
import api from '../../../api';

export default {
  title: 'ShiftPositions',
  components: { Instance },
  data() {
    return {
      shiftPositions: api.shiftPositions,
      operationalAreas: {},
      upsert: []
    };
  },
  async created() {
    this.operationalAreas = await api.operationalArea.get();
    this.upsert = [
      { value: 'number', name: 'Number', required: true },
      { value: 'name', name: 'Name', required: true },
      { value: 'abbreviations', name: 'Abbreviations', required: true },
      {
        value: 'operationalArea',
        name: 'Investments',
        type: 'multiselect',
        data: [
          ...this.operationalAreas.map(v => ({
            value: v.id,
            text: this.$translate(v.name)
          }))
        ],
        required: true
      },
      { value: 'color', name: 'Color', type: 'color', required: true }
    ];
  },
  methods: {
    columns({ editInstance }) {
      return [
        {
          field: 'check',
          key: '1',
          type: 'checkbox',
          title: '',
          width: 50,
          align: 'center'
        },
        {
          field: 'number',
          title: this.$translate('Number'),
          key: '2',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'name',
          title: this.$translate('Name'),
          key: '3',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'abbreviations',
          title: this.$translate('Abbreviations'),
          key: '31',
          sortBy: '',
          align: 'left'
        },
        {
          field: 'operationalAreaList',
          title: this.$translate('Investments'),
          key: '4',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div>{row.operationalArea ? row.operationalArea.map(o => this.$translate(o.name)).join(', ') : ''}</div>;
          }
        },
        {
          field: 'color',
          title: this.$translate('Color'),
          key: '5',
          sortBy: '',
          align: 'left',
          renderBodyCell: ({ row }) => {
            return <div class="color-box" style={`background:${row.color}`} />;
          }
        },
        {
          field: 'actions',
          title: '',
          key: '6',
          width: 110,
          renderBodyCell: ({ row }) => {
            return (
              <div class="action-block">
                <div class="details-action" on-click={() => editInstance(row)}>
                  <BIconPencil />
                </div>
              </div>
            );
          }
        }
      ];
    }
  }
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 150px;
  height: 30px;
}
</style>
